import { useRouter } from 'expo-router'
import { useEffect, type ReactNode } from 'react'

import { useUserConversationQuery } from '@/src/features/user/services/useUserConversationQuery'
import { useUserQuery } from '@/src/features/user/services/useUserQuery'
import { ErrorMessage } from '@/src/general/components/ErrorMessage'
import { useRoutes } from '@/src/general/utils/routes'

import { FirstConversation } from '../../../components/FirstConversation'
import { ConversationHeaderLayout } from './ConversationHeaderLayout'

type TNewConversationProps = {
  userId: number
  conversationId: number | undefined
}

export const NewConversation = ({ userId, conversationId }: TNewConversationProps): ReactNode => {
  const router = useRouter()
  const { routes } = useRoutes()

  const { data: user, error } = useUserQuery(userId)
  const { data: userConversationId } = useUserConversationQuery(userId)

  useEffect(() => {
    if (userConversationId) {
      router.replace(routes.conversationById(userConversationId))
    }
  }, [userConversationId, router, routes])

  return (
    <ConversationHeaderLayout user={user} openedConversationId={undefined}>
      {error ? (
        <ErrorMessage defaultErrorKey="contact.load.error" />
      ) : (
        <FirstConversation userId={userId} conversationId={conversationId} />
      )}
    </ConversationHeaderLayout>
  )
}
